// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__HODxx","additionalInfo":"AgreementModal_additionalInfo__2e5_t"};